import { useState } from 'react';
import ColorModeContext from '../context/ColorModeContext';
import { useEffect } from 'react';
import { getCookie, setCookie } from '../utils/cookies';
import { useConfig } from '../Hooks/useConfig';

const DarkModeProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(true);
  const { baseDomain } = useConfig();

  useEffect(() => {
    document.body.classList.remove(!darkMode ? 'dark' : 'light');
    document.body.classList.add(darkMode ? 'dark' : 'light');
  }, [darkMode]);
  useEffect(() => {
    const currentTheme =
      getCookie('darkMode') ||
      (window.matchMedia('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light');
    setDarkMode(currentTheme === 'dark');
  }, []);

  useEffect(() => {
    setCookie('darkMode', darkMode ? 'dark' : 'light', 34560000, baseDomain);
    // localStorage.setItem('darkMode', darkMode ? 'dark' : 'light');
  }, [darkMode]);
  const toggleDarkMode = () => setDarkMode((prevDarkMode) => !prevDarkMode);

  return (
    <ColorModeContext.Provider value={{ darkMode, toggleDarkMode }}>
      {children}
    </ColorModeContext.Provider>
  );
};
export default DarkModeProvider;
